import { Colors } from "@utils";
import React, { ComponentProps } from "react";
import styled from "styled-components";

interface TutorialGaugeProps extends ComponentProps<"div"> {
  page: number;
  maxPage: number;
}

const BG = styled.div`
  position: relative;
  height: 4px;
  border-radius: 2px;
  overflow: hidden;
  background: ${Colors.gray2};
`;

const Gauge = styled.div`
  position: absolute;
  border-radius: 2px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  background: ${Colors.primaryGreen};
`;

const TutorialGauge: React.FC<TutorialGaugeProps> = ({
  page,
  maxPage,
  ...rest
}) => {
  return (
    <BG>
      <Gauge style={{ width: (100 * page) / maxPage + "%" }} />
    </BG>
  );
};

export default TutorialGauge;
